export { getChartingThemeKey } from '@splunk/visualizations-shared/themeUtils';
